<template>
  <b-container fluid>
    <b-row>
      <b-col class="mb-3">
        <iq-card class-name="iq-card-block iq-card-stretch iq-card-height iq-user-profile-block">
          <template v-slot:default v-if="doctor">
            <div class="user-details-block">
              <div class="user-profile text-center" v-if="doctor.profilePic">
                <img :src="doctor.profilePic" alt="profile-img" class="profile-pic">
              </div>
              <div class="user-profile text-center" v-else>
                <img :src="defaultProfilePic" alt="profile-img" class="profile-pic">
              </div>
              <div class="text-center mt-3">
                <h4><b>{{ doctor.firstName }} {{ doctor.lastName }}</b></h4>
                <p v-if="doctor.position">{{ doctor.position }}</p>
                <p v-else>Doctor</p>
                <button @click="toEditProfile" class="btn btn-primary">My Profile</button>
              </div>
              <hr>
              <ul class="doctoe-sedual d-flex align-items-center justify-content-between p-0">
                <li class="text-center">
                  <h3 class="counter" v-if="doctor.patients">{{ doctor.patients.length }}</h3>
                  <h3 class="counter" v-else>0</h3>
                  <span>Patients</span>
                </li>
                <li class="text-center">
                  <h3 class="counter">3.9</h3>
                  <span>Medical Rating</span>
                </li>
              </ul>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
        <b-row>
          <b-col>
            <PatientsList v-if="!loadingPatients" :patients="patients"></PatientsList>
            <iq-card class="patients-list" v-else>
              <template v-slot:headerTitle>
                <h4 class="card-title">Patients</h4>
              </template>
              <template v-slot:headerAction>
                <div class="iq-search-bar">
                  <div class="searchbox">
                    <input type="text" class="text search-input" placeholder="Search" v-model="searchInput">
                    <span class="search-link"><i class="ri-search-line"></i></span>
                  </div>
                </div>
              </template>
              <template v-slot:default>
                <div class="spinner-border"></div>
              </template>
            </iq-card>
          </b-col>
        </b-row>
    <b-row>
      <b-col>
        <iq-card>
            <template v-slot:headerTitle>
            <h4 class="card-title">Your Schedule</h4>
          </template>
          <template v-slot:default>
            <div style="overflow-x:auto">
            <FullCalendar
              ref="fullCalendar"
              :options="calendarOptions"
            />
            <button @click="toBookAppointment" class="btn add-patient"><i class="ion-plus-circled"></i> BOOK APPOINTMENT</button>
            </div>

          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { xray } from '../../config/pluginInit'
import PatientsList from '../../components/PatientsList.vue'
import firebaseService from '../../../firebase'
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { onMounted, ref, watch } from 'vue'
import getDocument from '../../services/getDocument'
import _ from 'lodash'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import { useRouter } from 'vue-router'

export default {
  mounted () {
    xray.index()
  },
  components: { PatientsList, FullCalendar },
  setup () {
    const router = useRouter()
    const firebaseDoctor = firebaseService.firebaseAuth.currentUser
    const patients = ref([])
    const doctor = ref(null)
    const loadingPatients = ref(false)
    const defaultProfilePic = require('../../assets/images/user/11.png')

    const retrievePatients = httpsCallable(firebaseService.functions, 'retrievePatients')
    const { document: doctorDocument } = getDocument('doctors', firebaseDoctor.uid)
    const localStoragePatientsKey = `patients${firebaseDoctor.uid}`
    const localStorageDoctorKey = `doctor${firebaseDoctor.uid}`

    watch((doctorDocument), (newDocument) => {
      if (!localStorage.getItem(localStorageDoctorKey) ||
      (localStorage.getItem(localStorageDoctorKey) && !_.isEqual(JSON.parse(localStorage.getItem(localStorageDoctorKey)),
        JSON.parse(JSON.stringify(newDocument))))) {
        localStorage.setItem(localStorageDoctorKey, JSON.stringify(newDocument))
        console.log(JSON.stringify(newDocument))
        updateDoctorInfo()
        let patientsUids
        if (localStorage.getItem(localStoragePatientsKey)) {
          const patientsArray = JSON.parse(localStorage.getItem(localStoragePatientsKey))
          if (patientsArray) {
            patientsUids = patientsArray.map(each => {
              return each.uid
            })
          }
        }

        if (!localStorage.getItem(localStoragePatientsKey) ||
      (!_.isEqual(patientsUids, JSON.parse(JSON.stringify(newDocument.patients))))) {
          loadingPatients.value = true
          retrievePatients({ uid: firebaseDoctor.uid })
            .then(results => {
              loadingPatients.value = false
              patients.value = results.data
              localStorage.setItem(localStoragePatientsKey, JSON.stringify(results.data))
            })
        }
      }
    })

    const updateDoctorInfo = () => {
      doctor.value = JSON.parse(localStorage.getItem(localStorageDoctorKey))
      doctor.value.phoneNumber = firebaseDoctor.phoneNumber
      doctor.value.email = firebaseDoctor.email
    }

    // If doctor's and patients' data are stored in cache, fetch them
    onMounted(() => {
      if (localStorage.getItem(localStoragePatientsKey)) {
        patients.value = JSON.parse(localStorage.getItem(localStoragePatientsKey))
      }
      if (localStorage.getItem(localStorageDoctorKey) !== null) {
        updateDoctorInfo()
      }
    })

    // Calendar
    const fullCalendar = ref(null)
    watch(fullCalendar, () => {
      setTimeout(() => fullCalendar.value.getApi().updateSize(), 1000)
    })

    const calendarOptions = {
      plugins: [dayGridPlugin],
      initialView: 'dayGridMonth',
      height: '700px',
      headerToolbar: {
        left: 'title',
        right: 'today dayGridMonth,dayGridWeek,dayGridDay prev,next'
      },
      eventDisplay: 'block',
      events: function (info, successCallback, failureCallback) {
        const q = query(collection(firebaseService.db, 'appointments'), where('doctorID', '==', firebaseDoctor.uid))
        getDocs(q)
          .then(querySnapshot => {
            const events = []
            querySnapshot.forEach(doc => {
              events.push({
                id: doc.id,
                allDay: false,
                title: doc.data().isOnline ? 'Online' : 'In-person',
                color: doc.data().isOnline ? '#52b788' : '#5aa9e6',
                start: doc.data().datetime.toDate(),
                extendedProps: { userId: doc.data().userID, isOnline: doc.data().isOnline, location: doc.data().location }
              })
            })
            successCallback(Array.prototype.slice.call(events))
          }).catch(error => {
            failureCallback(error)
          })
      },
      eventDidMount: function (info) {
        info.el.classList.add('clickable')
        const newDiv = document.createElement('div')
        const patientView = document.createElement('p')
        const locationView = document.createElement('p')
        newDiv.appendChild(patientView)
        newDiv.appendChild(locationView)
        const button = document.createElement('button')
        button.appendChild(document.createTextNode('Profile'))
        button.classList.add('btn')
        button.classList.add('btn-primary')
        button.onclick = () => {
          router.push({ name: 'patients.patientDashboard', params: { uid: info.event.extendedProps.userId } })
        }
        newDiv.appendChild(button)

        const docRef = doc(firebaseService.db, 'users', info.event.extendedProps.userId)
        getDoc(docRef)
          .then(docSnap => {
            if (docSnap.exists()) {
              patientView.appendChild(document.createTextNode(`Patient: ${docSnap.data().firstName} ${docSnap.data().lastName}`))
              if (info.event.extendedProps.isOnline) {
                const link = document.createElement('a')
                link.appendChild(document.createTextNode('Call link'))
                link.href = info.event.extendedProps.location
                locationView.appendChild(link)
              } else {
                locationView.appendChild(document.createTextNode(`Location: ${info.event.extendedProps.location}`))
              }
            }

            tippy(info.el, {
              content: newDiv,
              theme: 'tomato',
              allowHTML: true,
              placement: 'right',
              interactive: true
            })
          })
      }
    }

    const toEditProfile = () => {
      router.push({ name: 'dashboard.profile' })
    }

    const toBookAppointment = () => {
      router.push({ name: 'app.calendar' })
    }

    return {
      patients,
      loadingPatients,
      doctor,
      defaultProfilePic,
      fullCalendar,
      calendarOptions,
      toEditProfile,
      toBookAppointment
    }
  }
}
</script>

<style scoped>
  .profile-pic{
    height: 130px; width: 130px; line-height: 130px; font-size: 1.6rem;
    margin: auto;
  }

   .btn.add-appointment {
        background-color: #b583bc;
        color: white;
        margin-right: 15px;
    }

        .btn.add-patient {
        font-size: 15px;
        background-color: #b583bc;
        color: white;
        padding: 10px 15px;
        margin: 15px 15px 15px 0;
        float: right;
    }

</style>

<style>
    .clickable {
      cursor: pointer;
    }

    .fc .fc-button-primary {
      background: #AD9EB0;
      border-color: #AD9EB0;
    }

    .fc .fc-button-primary:not(:disabled):hover {
      background: #b583bc;
      border-color: #b583bc;
    }

    .fc .fc-button-primary:not(:disabled):active, .fc .fc-button-primary:not(:disabled).fc-button-active {
      background: #b583bc;
      border-color: #b583bc;
    }
</style>
